import { render, staticRenderFns } from "./CaijinPage.vue?vue&type=template&id=2baca426&"
import script from "./CaijinPage.vue?vue&type=script&lang=js&"
export * from "./CaijinPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports